export const DOCUMENT_ALLOWED_FILE_TYPES = [
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'video/mp4',
    'video/quicktime'
]

export const DOCUMENT_MAX_FILE_SIZE_BYTES = 26214400; // 25 MB